import React, { FC } from 'react';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import { WixRicosViewer } from '@wix/ricos-viewer';

import {
  useInstance,
  useDefaultBIParams,
  useMember,
} from '../../../../../../contexts/widgets';
import { biSettings, plugins } from './config';

import '../../../common/RCE/ricos.global.scss';

export const Viewer: FC = () => {
  const { isMobile, language } = useEnvironment();
  const { instance } = useInstance();
  const { defaultBIParams } = useDefaultBIParams();
  const { experiments } = useExperiments();
  const { id, about } = useMember();

  return (
    <WixRicosViewer
      content={about}
      plugins={plugins}
      instance={instance}
      wixExperiments={experiments}
      isMobile={isMobile}
      locale={language}
      biSettings={{
        ...biSettings,
        contentId: id ?? undefined,
        defaultParams: defaultBIParams,
      }}
    />
  );
};
